import React from "react"
import * as comp from "./tiles"

export default function SubmitPage({submit}: {submit: any}) {


    return (
        <div>
            <comp.Row alignment="center">
                <comp.Button label="Resubmit" color="red" onChange={submit}/>
                <comp.Button label="Reset" color="blue" onChange={() => window.location.reload()}/>
            </comp.Row>
        </div>
    )
}